import {
  Tooltip,
  TooltipFetchArgs,
  getTooltips,
} from '../assets/ts/data/tooltip'
import useServerData from './use-server-data'

function useTooltipMetadata(
  fetchArgs: TooltipFetchArgs,
  waitOnParentDependency = false
) {
  const {
    data: tooltipMetadata,
    error: tooltipMetadataError,
    fetchData: fetchTooltipMetdata,
    isLoading: tooltipMetadataIsLoading,
  } = useServerData<Tooltip, TooltipFetchArgs>(
    getTooltips,
    fetchArgs,
    waitOnParentDependency
  )

  return {
    fetchTooltipMetdata,
    tooltipMetadata,
    tooltipMetadataError,
    tooltipMetadataIsLoading,
  }
}

export default useTooltipMetadata
